<template>
  <div id="app">
    <ConfigProvider
      :theme="{
        ...appConfig,
        algorithm: theme.darkAlgorithm,
      }"
      :locale="getCurrLocale"
    >
      <div class="app-loader" v-if="middlewareLoading">
        <RexLoading />
      </div>
      <router-view></router-view>
      <contextHolder />
    </ConfigProvider>
  </div>
</template>
<script>
import { ConfigProvider } from 'ant-design-vue';
import { theme } from 'ant-design-vue';
import { appConfig } from '@/utils/theme/app.theme.config';
import { contextHolder } from '@/utils/notification';
import i18n from '@/plugins/i18n';
import ja_JP from 'ant-design-vue/es/locale/ja_JP';
import { mapMutations, mapState } from 'vuex';
import RexLoading from './rex-components/rex-loading.vue';

// TODO: temporary fix for async warning.
global.ASYNC_VALIDATOR_NO_WARNING = 1;
export default {
  name: 'App',
  components: { ConfigProvider, contextHolder, RexLoading },
  computed: {
    ...mapState('globalState/app', ['middlewareLoading']),
    getCurrLocale() {
      return i18n.global.locale === 'ja' ? ja_JP : null;
    },
  },
  data() {
    return { theme, appConfig };
  },
  methods: {
    ...mapMutations('globalState/app', ['setPermissions']),
  },
  beforeMount() {
    this.setPermissions();
  },
};
</script>
<style lang="scss">
@import './assets/styles/_index.scss';

#app,
html {
  font-family: RakutenSansUI-Regular !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: none;
  text-align: center;
  color: $font-primary;
  background-color: $bg-primary !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  outline: none;
  text-decoration: none;
  button:focus {
    outline: 0;
  }
  ::-webkit-scrollbar {
    width: 0.25rem;
    height: 0rem;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 0.25rem;
  }
}

body {
  margin: 0;
  padding: 0;
  // overflow: hidden;
  // font-size: $base-font-size;
  background-color: $bg-primary !important;
  font-family: $regular !important;
  height: 100vh;
  outline: none !important;
  textarea:focus,
  input:focus {
    outline: none;
  }

  -youbkit-touch-callout: none; /* iOS Safari */
  -youbkit-user-select: none; /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none;
}
html {
  font-size: 16px;
}
@media only screen and (max-width: 1700px) {
  #app,
  html {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 1600px) {
  #app,
  html {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 1500px) {
  #app,
  html {
    font-size: 12px !important;
  }
}

.app-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba($color: $bg-dark-black, $alpha: 0.3);
}
</style>
